import React from "react";
import PropTypes from "prop-types";

import { SystemBanner } from "account/systembanner";

import styles from "./topnav.css";

export function TopNav() {
  return (
    <div className={styles.topNavWrapper}>
      <SystemBanner />
      <div id="topnavcontainer" className={`${styles.topnav} shadow-8dp`} />
    </div>
  );
}

TopNav.propTypes = {
  topMenu: PropTypes.any
};

export { CommonTopnav } from "./common.topnav.jsx";
export { MainTopnav } from "./main.topnav.jsx";
export { BaseTopNav } from "./components/base_topnav/index.jsx";
export { AccountLogo } from "./components/account_logo/index.jsx";
export { UserProfile } from "./components/user_profile/index.jsx";
export { Help } from "./components/help/index.jsx";
